import React, { useState } from 'react';

const LoginBackground = ({ children, passwordLen = 0 }) => {
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const isComplete = passwordLen >= 8;
    // Colores más sutiles y elegantes para entornos enterprise
    const glowColor = isComplete ? 'rgba(16, 185, 129, 0.08)' : 'rgba(14, 165, 233, 0.08)';
    const cursorGlow = isComplete ? 'rgba(16, 185, 129, 0.12)' : 'rgba(14, 165, 233, 0.12)';

    const handleMouseMove = (e) => {
        setMousePos({ x: e.clientX, y: e.clientY });
    };

    return (
        <div
            onMouseMove={handleMouseMove}
            className="relative flex items-center justify-center min-h-screen w-screen bg-[#060b14] overflow-hidden font-sans"
        >
            {/* 1. MATRIZ DE PUNTOS CLÍNICA (Más limpia que las líneas) */}
            <div
                className="absolute inset-0 z-[1] opacity-60"
                style={{
                    backgroundImage: `radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px)`,
                    backgroundSize: '32px 32px'
                }}
            />

            {/* 2. VIÑETA OSCURA (Oscurece los bordes para centrar la atención) */}
            <div className="absolute inset-0 z-[2] bg-[radial-gradient(circle_at_center,transparent_0%,#060b14_100%)] opacity-90" />

            {/* 3. NEBULOSA CENTRAL (Estado de la contraseña) */}
            <div
                className="absolute w-[80vw] h-[80vh] transition-colors duration-[1000ms] ease-in-out z-[3] rounded-full blur-[120px]"
                style={{
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: `radial-gradient(circle at center, ${glowColor} 0%, transparent 60%)`
                }}
            />

            {/* 4. LINTERNA DE SEGUIMIENTO (Sigue al ratón a 60fps) */}
            <div
                className="absolute w-[500px] h-[500px] pointer-events-none z-[4] blur-[80px] transition-colors duration-500"
                style={{
                    top: mousePos.y - 250,
                    left: mousePos.x - 250,
                    background: `radial-gradient(circle, ${cursorGlow} 0%, transparent 70%)`
                }}
            />

            {/* CONTENEDOR PRINCIPAL */}
            <div className="relative z-10 w-full">
                {children}
            </div>
        </div>
    );
};

export default LoginBackground;